/**
*
* PluginsPage
*
*/

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  Button,
  List,
  ListBody,
  ListItem,
  ListItemColumn,
  MaterialIcon,
} from '@pearsontechnology/aero-components';

import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import {
  commandWorkspacePluginList,
  commandWorkspacePluginCreate,
  commandWorkspacePluginDelete,
} from 'containers/ConnectionManager/actions';
import {
  selectPluginList,
  selectPluginCreateStatus,
} from 'Workspace/Plugins/store/selectors';
import WorkspaceHeader from 'Workspace/components/WorkspaceHeader';
import Sidebar from 'Workspace/components/WorkspaceSidebar';
import HomeNavigation from 'Workspace/components/HomeNavigation';
import { ActionTypes } from 'constants/enums';

import PlaceholderList from 'components/PlaceholderList';
import meShape from 'Workspace/types/me';
import { selectCurrentMe } from 'data/CurrentUser/selectors';
import gtmService from 'utils/gtm/gtmService';

import {
  PageWrapper,
  PageViewport,
  PageActions,
  PageActionsRight,
  PageContent,
} from 'components/PageStyles';
import PluginsListItemActions from './PluginsListItemActions';
import {
  ListTitle,
  PluginName,
  PluginIcon,
  PluginColumnText,
} from './styles';

import messages from './messages';

TimeAgo.locale(en);

const timeAgo = new TimeAgo('en-US');
const getElapsedTime = (date) => timeAgo.format(new Date(date));
class PluginsPage extends React.Component {
  componentDidMount() {
    this.props.getPlugins();
    if (this.props.location) {
      const { pathname } = this.props.location;
      gtmService.pushTelemetryPageActivityAndView({ pageName: pathname });
    }
  }

  onAction = (type, plugin) => {
    switch (type) {
      case ActionTypes.DELETE:
        this.props.deletePlugin(plugin.pluginId);
        break;
      default:
        break;
    }
  }

  render() {
    const { plugins, createPlugin, creatingPlugin, currentUser } = this.props;

    return (
      <PageWrapper>
        <Sidebar navigation={<HomeNavigation selectedKey="plugins" />} />

        <PageViewport>
          <WorkspaceHeader title={intl.formatMessage(messages.plugins)} />
          <PageActions>
            <PageActionsRight>
              <Button isLoading={creatingPlugin} primary loadable onClick={createPlugin}>
                <MaterialIcon left id="add" />
                {intl.formatMessage(messages.plugin)}
              </Button>
            </PageActionsRight>
          </PageActions>
          <PageContent>
            <ListTitle>{intl.formatMessage(messages.devPlugins)}</ListTitle>
            <List>
              {plugins ?
                <ListBody>
                  {plugins
                    .sort((a, b) => new Date(b.updatedAt || b.createdAt) - new Date(a.updatedAt || b.createdAt))
                    .map((plugin) => (
                      <ListItem key={plugin.pluginId} compact>
                        <ListItemColumn colWidth="45%">
                          <PluginName to={`/plugins/${plugin.pluginId}`}>
                            <PluginIcon />
                            {plugin.name}
                          </PluginName>
                        </ListItemColumn>
                        <ListItemColumn colWidth="33%">
                          <PluginColumnText>{plugin.creator && plugin.creator.email}</PluginColumnText>
                        </ListItemColumn>
                        <ListItemColumn colWidth="18%">
                          <PluginColumnText>{getElapsedTime(plugin.updatedAt || plugin.createdAt)}</PluginColumnText>
                        </ListItemColumn>
                        <ListItemColumn colWidth="34px" colWidthMobile="34px" grow="0">
                          <PluginsListItemActions
                            plugin={plugin}
                            currentUser={currentUser}
                            onAction={this.onAction}
                          />
                        </ListItemColumn>
                      </ListItem>
                    ))}
                </ListBody> :
                <PlaceholderList />
              }
            </List>
          </PageContent>
        </PageViewport>
      </PageWrapper>
    );
  }
}

PluginsPage.propTypes = {
  plugins: PropTypes.array,
  getPlugins: PropTypes.func,
  createPlugin: PropTypes.func,
  creatingPlugin: PropTypes.bool,
  currentUser: meShape,
  deletePlugin: PropTypes.func,
  location: PropTypes.object,
};

const mapDispatchToProps = (dispatch) => ({
  getPlugins: () => dispatch(commandWorkspacePluginList()),
  createPlugin: () => dispatch(commandWorkspacePluginCreate(
    intl.formatMessage(messages.defaultPluginName)
  )),
  deletePlugin: (pluginId) => dispatch(commandWorkspacePluginDelete(pluginId)),
});

const mapStateToProps = (state) => ({
  plugins: selectPluginList(state),
  creatingPlugin: selectPluginCreateStatus(state),
  currentUser: selectCurrentMe(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(PluginsPage);
